const FieldSkeleton = () => (
  <div className="mt-2 flex items-center py-1 px-[12px] animate-pulse">
    <div className="w-10 h-3 bg-gray-300 rounded-md" />
    <div className="ml-6 w-28 h-3 bg-gray-300 rounded-md" />
  </div>
);

export default FieldSkeleton;
